<template>
  <div class="success-layout flex flex-col">
    <TheShamrockBackground
      v-if="shamrock"
      :count="6"
      :height="180"
      horizontal-margin="-2.75rem"
      shamrock-class="inner-shamrock"
      type="white"
      :width="180"
    />

    <main class="content-wrap flex-1 px-100">
      <slot />
    </main>

    <TheBottomNavigation />
  </div>
</template>

<script lang="ts" setup>
type SuccessLayoutProps = { shamrock?: boolean }
defineProps<SuccessLayoutProps>()
</script>

<style lang="scss" scoped>
.success-layout {
  min-height: 100dvh;
  padding-bottom: $main-bottom-navigation-height;

  main {
    position: relative;
  }

  @for $i from 1 through 7 {
    :deep(.inner-shamrock:nth-child(#{$i})) {
      opacity: 0.7 - $i * 0.1;
    }
  }
}
</style>
